module.exports = __webpack_public_path__ + "img/cbr-quest-result.53603609.svg";